import { useNavigate } from 'react-router-dom';

type SmartNavigateOptions = {
  newTab?: boolean;
  replace?: boolean;
};

export function useSmartNavigate() {
  const navigate = useNavigate();

  return (url: string, options?: SmartNavigateOptions) => {
    const isExternal = /^(https?:\/\/|mailto:|tel:)/i.test(url);

    if (isExternal) {
      if (options?.newTab) {
        window.open(url, '_blank', 'noopener,noreferrer');
      } else {
        window.location.href = url;
      }
    } else {
      navigate(url, { replace: options?.replace });
    }
  };
}
